import { Skeleton } from '@mui/material';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

export interface PointRecord {
    createTime: string | number;
    taskName: string;
    score: number;
}

interface Props {
    records: PointRecord[];
    loading?: boolean;
}

const Wrapper = styled.div`
    width: 100%;

    margin: 0 auto;
    margin-top: 2rem;

    padding: 2rem;
    background-color: #fff;
    border-radius: 20px;
`;

const Title = styled.h2`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 24px;
    color: #000;
`;

const TableContainer = styled.div`
    background: #fff;
    /* border-radius: 12px; */
    overflow: hidden;
`;

const TableHeader = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 16px 24px;
    background: #f5f7ff;
    border-radius: 12px;
    font-size: 14px;
    color: #111827;
    font-weight: 500;

    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 12px;
    }
`;

const TableRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 24px;
    border-bottom: 1px solid #f3f4f6;
    font-size: 14px;
    color: #111827;
    align-items: center;

    &:last-child {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        padding: 16px;
        font-size: 12px;
    }
`;

const HeaderCell = styled.div`
    &:nth-child(2) {
    }
    &:nth-child(3) {
        text-align: right;
    }
`;

const Cell = styled.div`
    &:nth-child(2) {
    }
    &:nth-child(3) {
        text-align: right;
        font-weight: 600;
    }
`;

const formatDate = (date: string | number) => {
    if (!date) return '-';
    // Format: MM/DD/YYYY hh:mm:ss A EST
    return moment(date).format('MM/DD/YYYY hh:mm:ss A') + ' EST';
};

export const PointsTable: React.FC<Props> = ({ records, loading }) => {
    if (loading) {
        return (
            <Wrapper>
                <Title>My Points Earning History</Title>
                <TableContainer>
                    <TableHeader>
                        <HeaderCell>Date & Time</HeaderCell>
                        <HeaderCell>Activity</HeaderCell>
                        <HeaderCell>Points</HeaderCell>
                    </TableHeader>
                    {[1, 2, 3, 4, 5].map((i) => (
                        <TableRow key={i}>
                            <Cell>
                                <Skeleton width="80%" />
                            </Cell>
                            <Cell>
                                <Skeleton width="60%" />
                            </Cell>
                            <Cell
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Skeleton width="40px" />
                            </Cell>
                        </TableRow>
                    ))}
                </TableContainer>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            <Title>My Points Earning History</Title>
            <TableContainer>
                <TableHeader>
                    <HeaderCell>Date & Time</HeaderCell>
                    <HeaderCell>Activity</HeaderCell>
                    <HeaderCell>Points</HeaderCell>
                </TableHeader>
                {records.length === 0 ? (
                    <div
                        style={{
                            padding: '24px',
                            textAlign: 'center',
                            color: '#6B7280',
                        }}
                    >
                        No history found
                    </div>
                ) : (
                    records.map((record, index) => (
                        <TableRow key={index}>
                            <Cell>{formatDate(record.createTime)}</Cell>
                            <Cell>{record.taskName}</Cell>
                            <Cell>+{record.score}</Cell>
                        </TableRow>
                    ))
                )}
            </TableContainer>
        </Wrapper>
    );
};
